import {Component, computed, input} from '@angular/core';
import {Card, CardType} from "../../model/scorecard-model";
import {NgForOf, NgSwitch, NgSwitchCase} from "@angular/common";
import {GroupCard} from "../../model/group-card-model";
import {CourseCardComponent} from "../course/course-card.component";
import {ParticipantCardComponent} from "../participant/participant-card.component";
import {TeamCardComponent} from "../team/team-card.component";

@Component({
    selector: 'group-card',
    templateUrl: './group-card.component.html',
    imports: [
        NgForOf,
        NgSwitchCase,
        NgSwitch,
        CourseCardComponent,
        ParticipantCardComponent,
        TeamCardComponent
    ],
    styleUrls: ['./group-card.component.css']
})
export class GroupCardComponent {
    card = input.required<Card>();

    groupCard = computed(() => {
        return this.card() as GroupCard;
    });

    name = computed(() => {
        return this.groupCard().name
    });

    cards = computed(() => {
        return this.groupCard().cards
    });

    trackByCardType(_: number, card: Card) {
        return card.type;
    }

    protected readonly CardType = CardType;
}
